import { Link } from 'react-router';
import { usePwlLabWait } from '@hooks/register/use-pwl-lab-wait';
import { useLocalize } from '@hooks/use-localize';
import { useSession } from '@hooks/security/use-session';
import type { IPwlLabWaitModel } from '@/types/history/pwl-lab-wait';
import PageLoader from '@components/page-loader';

const PwlLabWait = () => {
    const { registrationId, editKey } = useSession();
    const { model, isLoading, error } = usePwlLabWait(registrationId, editKey);

    return (
        <div className="container-fluid">
            <PageLoader isLoading={isLoading} error={error}>
                {!error && <PwlLabWaitContent model={model} />}
            </PageLoader>
        </div>
    );
};

interface IPwlLabWaitContentProps {
    model: IPwlLabWaitModel;
}

const PwlLabWaitContent = ({ model }: IPwlLabWaitContentProps) => {
    const t = useLocalize(model.languageData);

    return (
        <div className="row row-margined">
            <div className="col-xs-12 col-sm-7 col-sm-offset-0">
                <div className="row row-margined">
                    <div className="col-xs-12">
                        <h1>{t('DashLabel_ThankYou', 'Thank You')}</h1>
                        <p>
                            {t(
                                'DashLabel_AlrightYouReAllDoneForNowWeLlCheckWithYouAgainInAbout2Weeks',
                                "Alright. You're all done for now.  We'll check with you again in about 2 weeks to see if you are ready for the labs",
                            )}
                            .
                        </p>
                    </div>
                </div>

                <div className="row row-margined">
                    <div className="col-xs-12">
                        <Link className="btn btn-primary" to="/register/donate">
                            {t('DashLabel_BackToDashboard', 'Back to Dashboard')}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PwlLabWait;
